require('./src/styles/global.scss');